import { Stack, Typography } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';
import { useState } from 'react';

import ConfirmationDialog from '@/components/dialogs/confirmationDialog';
import OptionMenu from '@/components/option-menu';
import { useRoles } from '@/contexts/useRoles';

export const RansomwareByConditionViewerHeader = ({
  onSave,
  onEdit,
}: {
  onSave: (
    condition?: Condition,
    include?: string[],
    exclude?: string[]
  ) => Promise<void>;
  onEdit: (event: React.MouseEvent<HTMLElement>) => void;
}) => {
  const { isAuthorized } = useRoles();
  const [clearDialogIsOpen, setClearDialogIsOpen] = useState(false);

  const onClearAllClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setClearDialogIsOpen(true);
  };

  const clearAll = () => {
    return onSave();
  };

  return (
    <>
      <Stack
        width='100%'
        direction='row'
        alignItems='center'
        justifyContent='space-between'
      >
        <Typography variant='h4'>Dynamic resource selection</Typography>
        <OptionMenu
          iconClassName='text-textPrimary'
          icon='material-symbols-more-horiz'
          options={[
            {
              testId: 'edit-policy',
              text: 'Edit',
              menuItemProps: {
                disabled: !isAuthorized('update:security_plan'),
                onClick: onEdit,
              },
            },
            {
              testId: 'clear-all-policies',
              text: 'Clear All',
              menuItemProps: {
                disabled: !isAuthorized('update:security_plan'),
                onClick: onClearAllClick,
              },
            },
          ]}
        />
      </Stack>
      <ConfirmationDialog
        isOpen={clearDialogIsOpen}
        title='Clear all resources assignment'
        description='Removing this condition stops ransomware detection on matching resources.'
        onCancel={() => setClearDialogIsOpen(false)}
        onConfirm={clearAll}
        confirmSnackbarText='Ransomware condition was cleared'
        buttonTitle='Clear All'
      />
    </>
  );
};
